// Expense Type Mutations

export const updateExpenseTypeList = (state, payload) => {
  state.expenseTypeList = payload
}

export const fetchExpenseTypeInfo = (state, payload) => {
  state.expenseTypeInfo = payload
}

export const setFullExpenseTypesList = (state, payload) => {
  state.fullExpenseTypesList = payload
}
